/**
 * 单价
 */
const UnivalentRouter = {
  path: '/purchasex',
  component: () => import('@/views/layout'),
  redirect: '/administration/purchase/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: '/administration/purchase/add_univalent',
      name: 'addUnivalent',
      component: () => import('@/views/administration_manage/purchase_manage/price/add_univalent'),
      hidden: true,
      meta: {
        title: '添加单价'
      }
    },
    {
      path: '/administration/purchase/edit_univalent/:id',
      name: 'editUnivalent',
      component: () => import('@/views/administration_manage/purchase_manage/price/add_univalent'),
      hidden: true,
      meta: {
        title: '编辑单价'
      }
    },
    {
      path: '/administration/purchase/univalent_info/:id',
      name: 'univalentInfo',
      component: () => import('@/views/administration_manage/purchase_manage/price/univalent_info'),
      hidden: true,
      meta: {
        title: '详情'
      }
    },
    {
      path: '/administration/purchase/add_monopoly',
      name: 'addMonopoly',
      component: () => import('@/views/administration_manage/purchase_manage/monopoly/add_monopoly'),
      hidden: true,
      meta: {
        title: '添加物品'
      }
    },
    {
      path: '/administration/purchase/edit_monopoly/:id',
      name: 'editMonopoly',
      component: () => import('@/views/administration_manage/purchase_manage/monopoly/add_monopoly'),
      hidden: true,
      meta: {
        title: '编辑物品'
      }
    },
    {
      path: '/administration/purchase/monopoly_info/:id',
      name: 'monopolyInfo',
      component: () => import('@/views/administration_manage/purchase_manage/monopoly/monopoly_info'),
      hidden: true,
      meta: {
        title: '详情'
      }
    },
    

  ]
}

export default UnivalentRouter
